import React from 'react';
import { MailIcon, ArrowLeftIcon, MapIcon, CalendarIcon, PresentationIcon, ChevronRightIcon, ShieldCheckIcon, FileTextIcon, ClipboardListIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function InvestorDeckPage() {
  return <div className="min-h-screen bg-gray-50 font-sans text-[#111111]" data-id="element-1635">
      {/* Private Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-1636">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-14 md:h-16 flex items-center justify-between" data-id="element-1637">
          <div className="flex items-center space-x-2 md:space-x-4 min-w-0" data-id="element-1638">
            <Link to="/" className="text-gray-500 hover:text-[#631bb7] transition-colors shrink-0" data-id="element-1639">
              <ArrowLeftIcon size={18} data-id="element-1640" />
            </Link>
            <div className="h-5 w-px bg-gray-200 shrink-0" data-id="element-1641"></div>
            <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-5 md:h-6 shrink-0" data-id="element-1642" />
            <span className="bg-gray-100 text-gray-600 text-[10px] md:text-xs font-semibold px-1.5 md:px-2 py-0.5 md:py-1 rounded-full uppercase tracking-wide shrink-0 hidden sm:inline-block" data-id="element-1643">
              Investor Portal
            </span>
          </div>
          <div className="text-xs md:text-sm text-gray-500 shrink-0" data-id="element-1644">
            Confidential
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 md:px-6 py-10 md:py-16 space-y-10 md:space-y-16" data-id="element-1645">
        {/* Welcome / Hero */}
        <section className="text-center max-w-3xl mx-auto" data-id="element-1646">
          <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6 text-[#111111]" data-id="element-1647">
            Welcome to the
            <br data-id="element-1648" />
            Caveo Investor Portal
          </h1>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed" data-id="element-1649">
            Access our strategic overview and product roadmap as we redefine
            family digital safety.
          </p>
        </section>

        {/* Collateral for Review */}
        <section className="max-w-4xl mx-auto" data-id="element-1650">
          <p className="text-xs md:text-sm font-medium text-gray-400 uppercase tracking-wider mb-3 md:mb-4" data-id="element-1651">
            Collateral for Your Review
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-1652">
            <Link to="/investor-overview" className="group bg-white rounded-2xl p-5 md:p-6 border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all no-underline flex items-center gap-4" data-id="element-1653">
              <div className="w-11 h-11 md:w-14 md:h-14 bg-[#f0ebf8] rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform shrink-0" data-id="element-1654">
                <img src="https://cdn.magicpatterns.com/uploads/5348RHTLEDdHjTfuxEoaok/Caveo-Icon-Solo-FC_100x80.png" alt="Caveo" className="w-5 h-5 md:w-7 md:h-7 object-contain" data-id="element-1655" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-1656">
                <h2 className="text-lg md:text-xl font-bold text-[#111111] mb-0.5" data-id="element-1657">
                  Product Overview
                </h2>
                <p className="text-sm text-gray-500" data-id="element-1658">
                  Our platform, philosophy, and how we serve families.
                </p>
              </div>
              <ChevronRightIcon size={20} className="text-gray-300 group-hover:text-[#631bb7] transition-colors shrink-0" data-id="element-1659" />
            </Link>

            <Link to="/investor-roadmap" className="group bg-white rounded-2xl p-5 md:p-6 border border-gray-200 shadow-sm hover:shadow-lg hover:border-[#631bb7] transition-all no-underline flex items-center gap-4" data-id="element-1660">
              <div className="w-11 h-11 md:w-14 md:h-14 bg-[#f0ebf8] rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform shrink-0" data-id="element-1661">
                <MapIcon size={22} className="text-[#631bb7]" data-id="element-1662" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-1663">
                <h2 className="text-lg md:text-xl font-bold text-[#111111] mb-0.5" data-id="element-1664">
                  Current Roadmap
                </h2>
                <p className="text-sm text-gray-500" data-id="element-1665">
                  Product strategy, feature roadmap, and development timeline.
                </p>
              </div>
              <ChevronRightIcon size={20} className="text-gray-300 group-hover:text-[#631bb7] transition-colors shrink-0" data-id="element-1666" />
            </Link>
          </div>
        </section>

        {/* Contact / Due Diligence */}
        <section className="bg-white rounded-2xl p-6 md:p-12 border border-gray-200 text-center max-w-4xl mx-auto" data-id="element-1667">
          <h2 className="text-xl md:text-2xl font-bold mb-3 md:mb-4" data-id="element-1668">
            Questions or Due Diligence Requests?
          </h2>
          <p className="text-sm md:text-base text-gray-600 mb-6 md:mb-8 max-w-2xl mx-auto" data-id="element-1669">
            We're happy to provide additional data room access or schedule a
            deep dive into our product roadmap and go-to-market strategy.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-3 md:gap-4" data-id="element-1670">
            <a href="mailto:jbp@caveohq.com" className="inline-flex items-center justify-center bg-[#631bb7] text-white px-5 md:px-6 py-3 rounded-lg font-semibold hover:bg-[#521099] transition-colors text-sm md:text-base" data-id="element-1671">
              <MailIcon size={16} className="mr-2" data-id="element-1672" />
              Email Us
            </a>
            <a href="https://calendar.app.google/EnoqEH7z4cY89jjN8" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-[#631bb7] text-white px-5 md:px-6 py-3 rounded-lg font-semibold hover:bg-[#521099] transition-colors text-sm md:text-base" data-id="element-1673">
              <CalendarIcon size={16} className="mr-2" data-id="element-1674" />
              Book a Meeting
            </a>
          </div>
        </section>

        {/* Ready to Invest? */}
        <section className="max-w-4xl mx-auto" data-id="element-1675">
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 md:p-10" data-id="element-1676">
            <div className="text-center mb-6 md:mb-8" data-id="element-1677">
              <h2 className="text-2xl md:text-3xl font-bold text-[#111111] mb-2" data-id="element-1678">
                Ready to Invest?
              </h2>
              <p className="text-sm md:text-base text-gray-500 max-w-xl mx-auto" data-id="element-1679">
                Here's what to expect when you proceed:
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-8" data-id="element-1680">
              <div className="flex items-start gap-3 bg-gray-50 rounded-xl p-4" data-id="element-1681">
                <div className="w-8 h-8 bg-[#f0ebf8] rounded-lg flex items-center justify-center shrink-0 mt-0.5" data-id="element-1682">
                  <ShieldCheckIcon size={16} className="text-[#631bb7]" data-id="element-1683" />
                </div>
                <div data-id="element-1684">
                  <p className="font-semibold text-sm text-[#111111] mb-1" data-id="element-1685">
                    Review Disclosures
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1686">
                    Important legal disclosures and accredited investor
                    requirements.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-gray-50 rounded-xl p-4" data-id="element-1687">
                <div className="w-8 h-8 bg-[#f0ebf8] rounded-lg flex items-center justify-center shrink-0 mt-0.5" data-id="element-1688">
                  <FileTextIcon size={16} className="text-[#631bb7]" data-id="element-1689" />
                </div>
                <div data-id="element-1690">
                  <p className="font-semibold text-sm text-[#111111] mb-1" data-id="element-1691">
                    Review SAFE Agreement
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1692">
                    Read through the terms of the SAFE investment agreement.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 bg-gray-50 rounded-xl p-4" data-id="element-1693">
                <div className="w-8 h-8 bg-[#f0ebf8] rounded-lg flex items-center justify-center shrink-0 mt-0.5" data-id="element-1694">
                  <ClipboardListIcon size={16} className="text-[#631bb7]" data-id="element-1695" />
                </div>
                <div data-id="element-1696">
                  <p className="font-semibold text-sm text-[#111111] mb-1" data-id="element-1697">
                    Submit Interest Form
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-1698">
                    We'll gather your info and send you a contract to sign.
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center" data-id="element-1699">
              <Link to="/invest" className="inline-flex items-center justify-center bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#521099] transition-colors text-base md:text-lg shadow-md no-underline" data-id="element-1700">
                Invest Now
                <ArrowRightIcon size={20} className="ml-2" data-id="element-1701" />
              </Link>
            </div>
          </div>
        </section>

        {/* Pitch Deck */}
        <section className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden max-w-4xl mx-auto" data-id="element-1702">
          <div className="flex items-center gap-3 px-6 py-4 border-b border-gray-100 bg-gray-50" data-id="element-1703">
            <PresentationIcon size={20} className="text-[#631bb7]" data-id="element-1704" />
            <h2 className="text-lg font-bold text-[#111111]" data-id="element-1705">Pitch Deck</h2>
          </div>
          <div className="w-full" style={{
          aspectRatio: '16/9'
        }} data-id="element-1706">
            <iframe src="https://docs.google.com/presentation/d/1fVC6uDiXaNJSw2id2Ss5M1aR9t8FIXEyFTrRizzsmzk/embed?start=false&loop=false&delayms=3000" className="w-full h-full border-0" allowFullScreen title="Caveo Pitch Deck" data-id="element-1707" />
          </div>
        </section>

        {/* Trust / Logo Strip */}
        <section className="max-w-4xl mx-auto" data-id="element-1708">
          <p className="text-center text-xs md:text-sm font-medium text-gray-400 uppercase tracking-wider mb-4 md:mb-6" data-id="element-1709">
            Built by leaders from
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-8 md:gap-x-12 gap-y-4 grayscale opacity-50" data-id="element-1710">
            <img src="https://cdn.magicpatterns.com/uploads/nmqUJqLxx2VskE1njSdPet/Experian_logo.svg.png" alt="Experian" className="h-6 md:h-8 max-w-[100px] md:max-w-[120px] object-contain" data-id="element-1711" />
            <img src="https://cdn.magicpatterns.com/uploads/fnXGBwy5K7uyX2UvFt6ups/Asana_logo.svg.png" alt="Asana" className="h-5 md:h-7 max-w-[80px] md:max-w-[100px] object-contain" data-id="element-1712" />
            <img src="https://cdn.magicpatterns.com/uploads/jTvJx4FmjnAA5ZM439Lq8G/drift-logo-png_seeklogo-394571.png" alt="Drift" className="h-5 md:h-7 max-w-[70px] md:max-w-[90px] object-contain" data-id="element-1713" />
            <img src="https://cdn.magicpatterns.com/uploads/vjVVFtuWSA5UFtZmC7CMpG/Intel-Logo.png" alt="Intel" className="h-6 md:h-8 max-w-[60px] md:max-w-[70px] object-contain" data-id="element-1714" />
            <img src="https://cdn.magicpatterns.com/uploads/gifY524awm2QkgRHAkporM/NBCUniversal_2026_Logo.svg" alt="NBCUniversal" className="h-5 md:h-7 max-w-[110px] md:max-w-[140px] object-contain" data-id="element-1715" />
          </div>
        </section>
      </main>

      <footer className="bg-white border-t border-gray-200 py-6 md:py-8 mt-auto" data-id="element-1716">
        <div className="max-w-7xl mx-auto px-4 md:px-6 text-center text-xs md:text-sm text-gray-500" data-id="element-1717">
          <p data-id="element-1718">&copy; 2026 AppEmbrace, Inc. DBA Caveo. All rights reserved.</p>
          <p className="mt-1 md:mt-2 text-xs text-gray-400" data-id="element-1719">
            This page contains confidential information intended only for
            authorized investors. Do not share or distribute without permission.
          </p>
        </div>
      </footer>
    </div>;
}